import React from "react";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";

import { WhiteListIpsModule } from "./WhiteListIps";

const WhiteListIps = (props) => {
  const { notifications } = props;

  return (
    <ErrorBoundary moduleName="whiteListIps" {...notifications}>
      <WhiteListIpsModule />
    </ErrorBoundary>
  );
};

export default WhiteListIps;
